import { useIntegrationEhrInfo } from '@/hooks/integrations/useIntegrationEhrInfo';
import { IntegrationLaunchSource } from '@heidi/integrations/ehr/contracts';

// Uses integrationLaunchSource (not deprecated integrationConnectionType) to cover all four integration types.
export const useHasActiveEhrIntegration = (): {
  hasActiveIntegration: boolean;
  isPending: boolean;
} => {
  const { integrationLaunchSource, isPending } = useIntegrationEhrInfo();

  return {
    hasActiveIntegration: integrationLaunchSource !== IntegrationLaunchSource.NONE,
    isPending,
  };
};
